import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {HttpClientModule} from '@angular/common/http';
import { NgProgressModule, NgProgress } from '@ngx-progressbar/core';
import { NgProgressHttpModule } from '@ngx-progressbar/http';
import { ButtonsModule } from 'ngx-bootstrap/buttons';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ExpedientesRoutingModule } from './expedientes-routing.module';
import { ListadoComponent } from 'app/modules/expedientes/listado/listado.component';
import { ExpedienteService } from '../../services/expediente.service';
import { AuthenticateService } from 'app/services/authenticate.service';
import { ExpedienteComponent } from './expediente/expediente.component';
import { EvaluacionService } from '../../services/evaluacion.service';
import { EvaluacionComponent } from 'app/modules/expedientes/evaluacion/evaluacion.component';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { ConvocatoriaService } from '../../services/convocatoria.service';
import { UniversidadComponent } from './expediente/universidad/universidad.component';
import { SafeURLPipe } from 'app/pipes/safe-url';
import { AsignacionComponent } from './asignacion/asignacion.component';
import { AsignacionEvaluacionesComponent } from './asignacion-evaluaciones/asignacion-evaluaciones.component';
import { EvaluacionRenovacionComponent } from './evaluacion-renovacion/evaluacion-renovacion.component';

@NgModule({
  imports: [
    CommonModule, HttpClientModule, NgbModule, FormsModule, ReactiveFormsModule, NgProgressModule, NgProgressHttpModule,
    ExpedientesRoutingModule, ButtonsModule.forRoot(), MultiselectDropdownModule
  ],
  declarations: [ListadoComponent, ExpedienteComponent, EvaluacionComponent, EvaluacionRenovacionComponent, UniversidadComponent,SafeURLPipe, AsignacionComponent, AsignacionEvaluacionesComponent],
  providers: [ExpedienteService, AuthenticateService, EvaluacionService, ConvocatoriaService],
  entryComponents:[AsignacionComponent,AsignacionEvaluacionesComponent]
  
})
export class ExpedientesModule { }



// WEBPACK FOOTER //
// /app/src/app/modules/expedientes/expedientes.module.ts